<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <poolsidebar></poolsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper">
          <div v-if="wtdata!==null" class="moduleCard">
            <wondertable :wtID="'poolLog'" :tcapiData="wtdata" :methods="wtmethods" :noRecords="'This Pool Has No Log'" :defaultDirection="1"
                         :ids="wids" :hasExportExcel="'1'" :hasExportPDF="'1'" :title="'Pool Log'" :burgerMenu="burgermenu" ref="thisWT" :paginationCount="logcount" :totalRecords="totalrecords"></wondertable>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>
<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import poolsidebar from "../../layout/Pool/Sidebar.vue"
  import wondertable from "../../components/WonderTable.vue"

  export default {
    name: 'PoolLogs',
    components: {acheader,acfooter,poolsidebar,wondertable},
    data() {
      return {
        burgermenu: [],
        logcount: null,
        wids: ["OperationID"],
        showTable: false,
        totalrecords:null,
        wtdata: null,
        wtmethods:{}
      }
    },
  methods: {
    async doCount(searchterm) {

        var fields={
          LicensePoolID: this.$route.params.id
        };

        if (searchterm!==null) {
          fields.SearchTerm=searchterm;
        }

        return this.apiCommand([
         {
           Operation: "LicensePool",
           Function: "GetPoolOperationLogCount",
           Fields: fields
         }        
        ]).then(response=>{
          try {
            var cr = JSON.parse(response.CommandResult);
            this.totalrecords= parseInt(cr.returnObjects[0].returnObject);
        
            if (this.totalrecords>500) {
              var excess=this.totalrecords%500;
              var pages = (this.totalrecords-excess)/500
              if (excess>0) {
                this.logcount=pages+1;
              }
              else {
                this.logcount=pages;
              }
            }
            else {
              this.logcount=1;
            }

            return true;
          }
          catch(e) {
            this.popDialog(1, "An unspecified error occurred");
          }

          return false;
        });
      },
      doWTPage(pg, isfirst, searchterm) {

        var fields = {
          LicensePoolID: this.$route.params.id,
          Take: 500
        };

        if (pg>0) {
          fields.Skip=(pg-1)*500;
        }

        if (searchterm!==null) {
          fields.SearchTerm=searchterm;
        }

        this.apiCommand([
         {
           Operation: "LicensePool",
           Function: "GetPoolOperationLogs",
           Fields: fields
         }        
        ]).then(response=>{
          try {
            var cr = JSON.parse(response.CommandResult);
            var data= JSON.parse(cr.returnObjects[0].returnObject);
            for(var entry of data) {
              entry.OperationText=this.fixOpText(entry.OperationText);
            }
         
            this.wtdata=data;
            if (!isfirst) {
              this.$refs["thisWT"].renderTable(data);
            }
  
          }
          catch(e) {
            this.popDialog(1, "An unspecified error occurred");
          }
        });
      },
      showAll(searchterm) {
        this.logcount=null;
        this.doWTPage(0, false, searchterm);
      }
    },
    mounted() {
      this.doPage().then(r=>{
        this.bootstrapPool(this.$route.params.id);
        this.doCount(null).then(r=>{
          if (r) {        
            this.doWTPage(1, true);
          }
        });

      });
    }
  }
</script>
